import {create} from 'zustand';

type ServiceHealthState = {
  /**
   * True while the sliding window of recent GraphQL queries shows the backend
   * shedding load (HTTP 503 or partial-shed 200+Retry-After over threshold —
   * see tracker.ts). Drives the "Service degraded" pill in the workspace view bar.
   */
  degraded: boolean;
  setDegraded: (degraded: boolean) => void;
};

export const useServiceHealthStore = create<ServiceHealthState>()(set => ({
  degraded: false,
  setDegraded: (degraded: boolean) => {
    set({degraded});
  },
}));
